import React from "react";
import { DocumentTextIcon, ArrowDownTrayIcon } from "@heroicons/react/24/outline";

const formatSize = (bytes) => {
  if (bytes == null || Number.isNaN(Number(bytes))) return null;
  const n = Number(bytes);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

const AnswerFile = ({ attachments }) => {
  const list = Array.isArray(attachments) ? attachments : [];
  if (list.length === 0) {
    return <p className="text-sm italic text-gray-400">No files uploaded</p>;
  }
  return (
    <ul className="space-y-2">
      {list.map((a) => {
        const name = a.upload_name || a.file_name || "Attachment";
        const size = formatSize(a.size_bytes);
        const downloadUrl = a.download_url || a.url || null;
        return (
          <li
            key={a.attachment_id}
            className="flex items-center gap-3 text-sm text-gray-800 bg-white border border-gray-200 rounded-lg px-3 py-2.5 hover:bg-gray-50 transition"
          >
            <DocumentTextIcon className="h-5 w-5 text-gray-400 shrink-0" />
            <span className="truncate flex-1 font-medium text-gray-800" title={name}>
              {name}
            </span>
            {size ? (
              <span className="text-xs text-gray-500 tabular-nums shrink-0">{size}</span>
            ) : null}
            {downloadUrl ? (
              <a
                href={downloadUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-7 w-7 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700 shrink-0"
                title="Download"
              >
                <ArrowDownTrayIcon className="h-4 w-4" />
              </a>
            ) : (
              <ArrowDownTrayIcon className="h-4 w-4 text-gray-400 shrink-0" aria-hidden="true" />
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default AnswerFile;
